import Modal from "react-modal";
import React from "react";
import {X} from "react-feather";

const ConversationDetailsModal = ({data = {}, onClose}) => {

    return <Modal
        isOpen={true}
        className="sl-modal-content sl-max-modal"
        overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
        <div className="sl-modal-body">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Conversation Details ID:{data.id}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0">
                    <X onClick={onClose}/>
                </div>
            </div>
            <div className="sl-modal-body">


                <div
                    className="sl-modal-body sl-max-h-112 sl-h-auto sl-px-6 sl-pb-0 sl-pt-24 sl-customized-scrollbar">
                    <div className="sl-flex sl-flex-col sl-gap-1">
                        <div className="sl-text-md sl-font-semibold sl-text-gray-900 ">
                            Message
                        </div>
                        <div className="sl-text-md sl-font-normal sl-text-gray-900 sl-max-h-95 sl-overflow-y-scroll">
                            {data.message}
                        </div>
                    </div>
                </div>


            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32"/>
        </div>
    </Modal>
}

export default ConversationDetailsModal;